import { orientationModuleService } from '@/services/api/orientationModule.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { orientationModuleModel } from '@/models/api/orientationModule.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const ORIENTATION_MODULE_MODULE = "api/orientationModule";

// ACTIONS
export const CREATE_ORIENTATION_MODULE = 'createOrientationModule';
export const GET_ORIENTATION_MODULE = 'getOrientationModule';
export const UPDATE_ORIENTATION_MODULE = 'updateOrientationModule';
export const UPDATE_ORIENTATION_MODULE_STATUS = 'updateOrientationModuleStatus';
export const UPDATE_ORIENTATION_MODULE_SEQUENCE = 'updateOrientationModuleSequence';
export const DELETE_ORIENTATION_MODULE = 'deleteOrientationModule';

// MUTATIONS
const REQUESTING = "requesting";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_ORIENTATION_MODULE_SUCCESS = "getOrientationModuleSuccess";

export const actions = {
    [CREATE_ORIENTATION_MODULE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return orientationModuleService
            .store(data)
            .then((result) => {
                let message = i18n.t('label.createX', [i18n.t('module.module')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [GET_ORIENTATION_MODULE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return orientationModuleService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_ORIENTATION_MODULE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return orientationModuleService
            .update(data)
            .then((result) => {
                let message = i18n.t('label.updateX', [i18n.t('module.module')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE_STATUS]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return orientationModuleService
            .updateStatus(data)
            .then((result) => {
                let message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('module.module')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE_SEQUENCE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return orientationModuleService
            .updateSequence(data)
            .then((result) => {
                let message = i18n.t('label.updateX', [i18n.t('label.sequence')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [DELETE_ORIENTATION_MODULE]({commit}, {uuid}) {
        commit(REQUESTING, 'save');
        return orientationModuleService
            .destroy(uuid)
            .then((result) => {
                let message = i18n.t('message.deleteXSuccess', [i18n.t('module.module')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
}

export const mutations = {
    [GET_ORIENTATION_MODULE_SUCCESS](state, data) {
        let item = data.data;
        state.details = orientationModuleModel(item);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
}

